// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';
import locale from 'element-ui/lib/locale/lang/en'
import App from './App'
import router from './router' //路由
import '../static/css/base.css'; //公共样式
import '../static/css/ele.css'; //ele修改样式
import VueCookie from 'vue-cookie'
import VueClipboard from 'vue-clipboard2' //粘贴板
// import VueI18n from 'vue-i18n' // 多语言
import '../static/css/compatible.css'
import { i18n } from './language/i18n_mounting' // 多语言

Vue.use(VueCookie)
Vue.use(VueClipboard)
// Vue.use(VueI18n)

import store from '@/store'; //Vuex
Vue.prototype.$store = store;

import apiInterface from "@/api/apiInterface"; //api
import enumInfo from "@/api/enum"; // 枚举
Vue.prototype.$enumInfo = enumInfo.cardhobby;
Vue.prototype.$interface = apiInterface.Interface;
import { post, get } from "@/api/axiosConfig"; // ajax请求封装
Vue.prototype.$get = get;
Vue.prototype.$post = post;

Vue.config.productionTip = false
// Vue.use(ElementUI, { locale });
Vue.use(ElementUI);

import '@/utils/route_guards.js' //路由守卫

function _isMobile() {
  let flag = navigator.userAgent.toLowerCase()
  flag = flag.match(/(phone|pad|pod|iphone|ipad|ipod|android)/i)
  if (flag) {
    window.location = process.env.VUE_APP_SHARE + '/download'
  }
}

// const i18n=new VueI18n({
//   locale:localStorage.getItem('lang') || 'en',
//   messages:{
//     zh: require("./language/zh.json"), 
//     en: require("./language/en.json"),
//   }
// })
/* eslint-disable no-new */
new Vue({
  router,
  i18n,
  render: h => h(App)
}).$mount('#app')



// WEBPACK FOOTER //
// ./src/main.js